/**
 * NOW Card Component
 * VOY-12: Shows immediate next action with context
 */

import { Button } from '@/components/ui/button';
import { Clock, Navigation } from 'lucide-react';
import { ActionButton } from '@/data/companion-timeline';

interface NowCardProps {
  currentTime: string;
  nextAction: string;
  context: {
    traffic?: string;
    weather?: string;
    info?: string;
  };
  actions: ActionButton[];
}

export function NowCard({ currentTime, nextAction, context, actions }: NowCardProps) {
  return (
    <div className="sticky top-0 z-10 bg-gradient-to-r from-[#5B6FED] to-[#8B9FED] text-white rounded-3xl p-6 shadow-xl shadow-purple-500/20 border border-white/20">
      {/* Header */}
      <div className="flex items-center gap-2 mb-4">
        <Clock className="w-6 h-6" />
        <h2 className="text-2xl font-bold">NOW - {currentTime}</h2>
      </div>

      {/* Next Action */}
      <div className="mb-4">
        <div className="flex items-start gap-3">
          <Navigation className="w-5 h-5 mt-1 flex-shrink-0" />
          <div>
            <p className="text-lg font-semibold mb-2">Next: {nextAction}</p>
            
            {/* Context Info */}
            <div className="space-y-1 text-white/90 text-sm">
              {context.traffic && (
                <p>🚗 {context.traffic}</p>
              )}
              {context.weather && (
                <p>🌤️ {context.weather}</p>
              )}
              {context.info && (
                <p>ℹ️ {context.info}</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      {actions.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {actions.map((action, index) => (
            <Button
              key={index}
              onClick={action.onClick}
              variant={action.variant === 'outline' ? 'outline' : 'default'}
              size="sm"
              className={
                action.variant === 'outline'
                  ? 'bg-white/20 text-white border-white/30 hover:bg-white/30 rounded-full'
                  : 'bg-white text-[#5B6FED] hover:bg-white/90 rounded-full'
              }
            >
              {action.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}

